"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const Button_1 = __importDefault(require("../../../common/js/atoms/Button"));
const ButtonSize_1 = __importDefault(require("../../../common/js/enums/ButtonSize"));
const ButtonVariant_1 = __importDefault(require("../../../common/js/enums/ButtonVariant"));
const Zupicons_1 = __importDefault(require("../../../common/js/enums/Zupicons"));
const translation_1 = require("../../../common/js/helper/translation");
const AnchoredDropdown_1 = __importDefault(require("../../atoms/AnchoredDropdown"));
const LicenseStore_1 = __importDefault(require("../../stores/LicenseStore"));
const AssetsSoftwareHeaderButtons = ({ onChange, options, rowsAreExpanded, toggleExpand, value, }) => {
    const [showFilterDropdown, setShowFilterDropdown] = (0, react_1.useState)(false);
    const [temporarySelectedFilter, setTemporarySelectedFilter] = (0, react_1.useState)([...value.filter]);
    const [temporaryShowDemoLicenses, setTemporaryShowDemoLicenses] = (0, react_1.useState)(value.showDemoLicenses);
    const toggleFilter = (option) => {
        if (temporarySelectedFilter.includes(option)) {
            setTemporarySelectedFilter(temporarySelectedFilter.filter((selected) => selected !== option));
        }
        else {
            setTemporarySelectedFilter([...temporarySelectedFilter, option]);
        }
    };
    (0, react_1.useEffect)(() => {
        if (showFilterDropdown) {
            setTemporarySelectedFilter([...value.filter]);
            setTemporaryShowDemoLicenses(value.showDemoLicenses);
        }
    }, [showFilterDropdown]);
    if (LicenseStore_1.default.rootTableLicenses.length === 0) {
        return null;
    }
    const someOptionsAreUnselected = temporarySelectedFilter.length < options.filter.length;
    const filterIsApplied = someOptionsAreUnselected || !temporaryShowDemoLicenses;
    return (react_1.default.createElement("div", { className: "d-flex flex-column flex-sm-row align-items-end align-items-sm-center ml-auto" },
        react_1.default.createElement("div", { className: "position-relative" },
            react_1.default.createElement(Button_1.default, { iconLeft: Zupicons_1.default.filter, onClick: () => setShowFilterDropdown(!showFilterDropdown), size: ButtonSize_1.default.small, text: (0, translation_1.t)('myassets.software.filter.title'), variant: filterIsApplied ? ButtonVariant_1.default.primary : ButtonVariant_1.default.gray }),
            react_1.default.createElement(AnchoredDropdown_1.default, { className: "znd-table-filter-dropdown", visible: showFilterDropdown, onClose: () => setShowFilterDropdown(false) },
                options.filter.map((option) => (react_1.default.createElement("div", { key: option, className: "znd-table-filter-dropdown__option-row" },
                    react_1.default.createElement("label", { className: "custom-control custom-checkbox znd-table-filter-dropdown__checkbox" },
                        react_1.default.createElement("input", { type: "checkbox", className: "custom-control-input", checked: temporarySelectedFilter.includes(option), onChange: () => toggleFilter(option) }),
                        react_1.default.createElement("span", { className: "custom-control-label" }, option))))),
                options.demoLicenseSelector ? (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("hr", { className: "znd-table-filter-dropdown__separator" }),
                    react_1.default.createElement("div", { className: "znd-table-filter-dropdown__option-row" },
                        react_1.default.createElement("label", { className: "custom-control custom-checkbox znd-table-filter-dropdown__checkbox" },
                            react_1.default.createElement("input", { type: "checkbox", className: "custom-control-input", checked: temporaryShowDemoLicenses, onChange: () => setTemporaryShowDemoLicenses(!temporaryShowDemoLicenses) }),
                            react_1.default.createElement("span", { className: "custom-control-label" }, (0, translation_1.t)('myassets.software.filter.labels.demo')))))) : null,
                react_1.default.createElement("hr", { className: "znd-table-filter-dropdown__separator" }),
                react_1.default.createElement(Button_1.default, { className: "justify-content-center", variant: ButtonVariant_1.default.primary, size: ButtonSize_1.default.block, text: (0, translation_1.t)('myassets.software.filter.confirm'), onClick: () => {
                        onChange({ filter: temporarySelectedFilter, showDemoLicenses: temporaryShowDemoLicenses });
                        setShowFilterDropdown(false);
                    } }))),
        react_1.default.createElement(Button_1.default, { className: "ml-2 mt-2 mt-sm-0", iconRight: Zupicons_1.default.arrowsVertical, onClick: toggleExpand, text: (0, translation_1.t)('myassets.software.expand_toggler', {
                expand: !rowsAreExpanded,
            }), variant: ButtonVariant_1.default.gray, size: ButtonSize_1.default.small })));
};
exports.default = AssetsSoftwareHeaderButtons;
